<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-container class="black--text d-flex justify-center" id="title-container">
    <v-card
      id="top-card-content-area"
      elevation="2"
      tile
      class="title-card topcard-width ma-2"
      style="border-radius: 20px !important"
    >
      <v-card-title
        class="d-flex title-card-text justify-center pa-0 topcard-width"
        style="line-height: 1.15"
      >
        <!-- <div class="topbar"></div> -->
        <div class="pa-4">{{ title }}</div>
      </v-card-title>
      <v-card-text class="d-flex flex-column justify-start align-center">
        <div style="font-size: 1.1rem; font-weight: 600">
          {{ descr_text }}
        </div>
        <v-btn v-if="show_admin_controls" class="mt-1" @click="art_add_first"
          >Add Article Top</v-btn
        >
      </v-card-text>
    </v-card>
  </v-container>
</template>
<style scoped>
.topcard-width {
  width: 100%;
}
.topbar {
  width: 100%;
  height: 18px;
  background-color: #00695c;
}
.bcs-expansion-content {
  color: black;
}
a_big_blue {
  font-size: 1.1rem;
}
@media (min-width: 768px) {
  #top-card-content-area {
    width: 100%;
    background-color: white;
    height: auto;
  }
}
@media (min-width: 1025px) {
  #top-card-content-area {
    width: 100%;
    background-color: white;
    height: auto;
  }
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "top_card",
  props: ["title", "descr_text", "rsrc"],
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {
    show_admin_controls() {
      return this.$store.state.show_admin_controls;
    },
  },
  methods: {
    art_add_first() {
      var payload = { rscr: this.rsrc };
      //payload.header.title = "";
      this.$emit("art_add_first", payload);
      return true;
    },
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
